import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const CourseStudent = React.lazy(() =>
    import('../CourseStudent')
);
const courseStudentRoutesRegistry = [
    {
        path: PAGE_URL.COURSE_STUDENT_PAGE,
        element: <CourseStudent />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default courseStudentRoutesRegistry;
